var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAutoworks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6 19.9c1.1.4 2.2.6 3.4.6 1.2 0 2.3-.2 3.4-.6l1.4 3.1h2.8l-1.9-4.3c2.4-1.8 4-4.7 4-7.9 0-4.8-3.4-8.8-7.9-9.6v2.7c3 .8 5.3 3.6 5.3 7 0 2.2-1 4.2-2.5 5.5L12 5.9 7.4 16.2c-1.5-1.3-2.5-3.3-2.5-5.5 0-3.1 2-5.8 4.8-6.8V1.2c-4.2 1.1-7.3 4.9-7.3 9.5 0 3.3 1.6 6.2 4 7.9l-1.9 4.3h2.8l1.3-3zm1.1-2.4l2.3-5.2 2.3 5.2c-.7.3-1.5.4-2.3.4s-1.6-.2-2.3-.4z"
  })));
}

export default SvgAutoworks;